import http from './http';

const getGerarBoleto = (id) => http.get(`/gerarBoleto/${id}`, { responseType: 'blob' });

export default getGerarBoleto;
